export const translations = {
  en: {
    lang: "EN",
    nav: {
      signUp: "Sign Up",
      signIn: "Sign In",
      features: "Features",
      pricing: "Pricing",
      support: "Support",
      dashboard: "Dashboard",
    },
    hero: {
      badge: "Free for every Shopify app partner",
      headline1: "360° growth for",
      headline2: "Shopify app partners",
      subheadline:
        "Track every payment, subscription, install, churn, and reinstall across your Shopify apps — with analytics and BigQuery traffic insights, plus merchant CRM, helpdesk, and reviews, all in one place.",
      cta: "Get Started Free",
      hint: "Setup in 15 min · Free forever · No credit card",
      alreadyHaveAccount: "Already have an account?",
      imageLabel: "Appdesh dashboard — payments, subscriptions, installs & churn at a glance (16:9)",
    },
    stats: {
      founders: "App founders using Appdesh",
      revenue: "Partner revenue tracked",
      setup: "Average setup time",
    },
    growthLoop: {
      heading: "One loop. Every stage of growth.",
      subheading:
        "Appdesh follows your merchants through the full lifecycle — so acquisition, support, and retention all live in one place.",
      diagramLabel: "360° growth loop diagram (square)",
      steps: [
        { title: "Acquire", description: "Bring merchants in through traffic insights and organic discovery." },
        { title: "Understand", description: "See revenue, MRR, churn, and a full merchant CRM across every app." },
        { title: "Support", description: "Resolve issues fast with a built-in helpdesk — no context-switching." },
        { title: "Retain", description: "Spot churn signals early and guide merchants through customer flows." },
        { title: "Grow", description: "Turn happy merchants into reviews and feed the next round of growth." },
      ],
    },
    features: {
      heading: "Everything a Shopify App Partner needs",
      subheading:
        "Stop context-switching between five tools. Appdesh brings your apps, merchants, and support into one focused workspace.",
      items: [
        {
          tagline: "Know your unit economics",
          title: "Revenue & App Analytics",
          description:
            "Sync your Shopify Partner API automatically. Track MRR, churn, and app performance across all your apps — no spreadsheets.",
          imageLabel: "Screenshot — Revenue & analytics dashboard",
        },
        {
          tagline: "Know your customers",
          title: "Merchant CRM",
          description:
            "A complete view of every merchant using your app — plan, install date, activity, and notes. Stop guessing who might churn.",
          imageLabel: "Screenshot — Merchant CRM detail",
        },
        {
          tagline: "Work as one team",
          title: "Team Members",
          description:
            "Invite your team, assign roles, and manage access — everyone stays in sync without sharing logins.",
          imageLabel: "Screenshot — Team members list",
        },
      ],
    },
    upcoming: {
      badge: "Coming soon",
      heading: "What's next for Appdesh",
      subheading:
        "We're building the next wave of Appdesh — helpdesk, experimentation, and integrations, with more on the way.",
      items: [
        {
          tagline: "Reply faster, retain more",
          title: "Customer Helpdesk",
          description:
            "Built-in helpdesk for your app customers. Track issues, respond quickly, and keep merchants happy without leaving Appdesh.",
          imageLabel: "Screenshot — Helpdesk inbox",
        },
        {
          tagline: "Test safely, ship gradually",
          title: "Feature Flags & Experiments",
          description:
            "Roll out experimental features to specific merchant groups, run A/B tests, and ship changes gradually — no redeploy required.",
          imageLabel: "Screenshot — Feature flags & experiments",
        },
        {
          tagline: "Connect your workflow",
          title: "Integrations",
          description:
            "Connect Appdesh to Slack and other tools your team already uses — get notified the moment something needs attention, and many more integrations on the way.",
          imageLabel: "Screenshot — Integrations hub",
        },
      ],
    },
    cta: {
      heading: "Ready to grow your Shopify app?",
      subheading: "Every feature included — free, no credit card required.",
      cta: "Sign Up Free",
      hint: "Setup in 15 min · No credit card required",
    },
    featuresPage: {
      heading: "Everything Appdesh does for Shopify App Partners",
      subheading: "One workspace for revenue analytics, merchant CRM, and your team — with more shipping every month.",
    },
    footer: {
      privacy: "Privacy Policy",
      dpa: "DPA",
      support: "Support",
      legal: "Legal Notice",
      rights: "All rights reserved.",
    },
  },

  de: {
    lang: "DE",
    nav: {
      signUp: "Registrieren",
      signIn: "Anmelden",
      features: "Funktionen",
      pricing: "Preise",
      support: "Support",
      dashboard: "Dashboard",
    },
    hero: {
      badge: "Kostenlos für jeden Shopify-App-Partner",
      headline1: "360°-Wachstum für",
      headline2: "Shopify-App-Partner",
      subheadline:
        "Verfolgen Sie jede Zahlung, jedes Abo, jede Installation, Kündigung und Reinstallation Ihrer Shopify-Apps — mit Analysen und BigQuery-Traffic-Insights, dazu Händler-CRM, Helpdesk und Bewertungen, alles an einem Ort.",
      cta: "Kostenlos starten",
      hint: "Einrichtung in 15 Min. · Für immer kostenlos · Keine Kreditkarte nötig",
      alreadyHaveAccount: "Bereits ein Konto?",
      imageLabel: "Appdesh-Dashboard — Zahlungen, Abos, Installationen & Churn auf einen Blick (16:9)",
    },
    stats: {
      founders: "App-Gründer nutzen Appdesh",
      revenue: "Partnerumsatz verfolgt",
      setup: "Durchschnittliche Einrichtungszeit",
    },
    growthLoop: {
      heading: "Ein Kreislauf. Jede Wachstumsphase.",
      subheading:
        "Appdesh begleitet Ihre Händler durch den gesamten Lebenszyklus — Akquise, Support und Bindung an einem Ort.",
      diagramLabel: "360°-Wachstumskreislauf-Diagramm (quadratisch)",
      steps: [
        { title: "Akquise", description: "Gewinnen Sie Händler über Traffic-Einblicke und organische Reichweite." },
        { title: "Verstehen", description: "Umsatz, MRR, Abwanderung und ein vollständiges Händler-CRM über alle Apps hinweg." },
        { title: "Support", description: "Lösen Sie Probleme schnell mit integriertem Helpdesk — ohne Tool-Wechsel." },
        { title: "Binden", description: "Erkennen Sie Abwanderungssignale früh und führen Sie Händler durch Customer Flows." },
        { title: "Wachsen", description: "Verwandeln Sie zufriedene Händler in Bewertungen und treiben Sie die nächste Wachstumsrunde an." },
      ],
    },
    features: {
      heading: "Alles, was ein Shopify-App-Partner braucht",
      subheading:
        "Hören Sie auf, zwischen fünf Tools hin- und herzuspringen. Appdesh bringt Ihre Apps, Händler und Support in einen fokussierten Arbeitsbereich.",
      items: [
        {
          tagline: "Verstehen Sie Ihre Wirtschaftlichkeit",
          title: "Umsatz- & App-Analysen",
          description:
            "Synchronisieren Sie die Shopify-Partner-API automatisch. Verfolgen Sie MRR, Abwanderung und App-Performance ohne Tabellenkalkulationen.",
          imageLabel: "Screenshot — Umsatz- & Analyse-Dashboard",
        },
        {
          tagline: "Kennen Sie Ihre Kunden",
          title: "Händler-CRM",
          description:
            "Vollständige Übersicht über jeden Händler — Plan, Installationsdatum, Aktivität und Notizen. Hören Sie auf zu raten, wer abwandern könnte.",
          imageLabel: "Screenshot — Händler-CRM-Detail",
        },
        {
          tagline: "Als ein Team arbeiten",
          title: "Teammitglieder",
          description:
            "Laden Sie Ihr Team ein, weisen Sie Rollen zu und verwalten Sie Zugriffsrechte — alle bleiben synchron, ohne Logins zu teilen.",
          imageLabel: "Screenshot — Teammitglieder-Liste",
        },
      ],
    },
    upcoming: {
      badge: "Demnächst verfügbar",
      heading: "Was als Nächstes bei Appdesh kommt",
      subheading:
        "Wir arbeiten an der nächsten Welle von Appdesh — Helpdesk, Experimente und Integrationen, mit noch mehr in Vorbereitung.",
      items: [
        {
          tagline: "Schneller antworten, mehr binden",
          title: "Kunden-Helpdesk",
          description:
            "Integrierter Helpdesk für Ihre App-Kunden. Verfolgen Sie Probleme und halten Sie Händler zufrieden, ohne Appdesh zu verlassen.",
          imageLabel: "Screenshot — Helpdesk-Posteingang",
        },
        {
          tagline: "Sicher testen, schrittweise ausrollen",
          title: "Feature Flags & Experimente",
          description:
            "Rollen Sie experimentelle Funktionen für ausgewählte Händlergruppen aus, führen Sie A/B-Tests durch und veröffentlichen Sie Änderungen schrittweise — ganz ohne erneutes Deployment.",
          imageLabel: "Screenshot — Feature Flags & Experimente",
        },
        {
          tagline: "Ihren Workflow verbinden",
          title: "Integrationen",
          description:
            "Verbinden Sie Appdesh mit Slack und anderen Tools, die Ihr Team bereits nutzt — werden Sie sofort benachrichtigt, wenn etwas Aufmerksamkeit braucht, mit weiteren Integrationen in Vorbereitung.",
          imageLabel: "Screenshot — Integrationen-Übersicht",
        },
      ],
    },
    cta: {
      heading: "Bereit, Ihre Shopify-App zu vergrößern?",
      subheading: "Alle Funktionen inklusive — kostenlos, keine Kreditkarte nötig.",
      cta: "Kostenlos registrieren",
      hint: "Einrichtung in 15 Min. · Keine Kreditkarte erforderlich",
    },
    featuresPage: {
      heading: "Alles, was Appdesh für Shopify-App-Partner bietet",
      subheading: "Ein Arbeitsbereich für Umsatzanalysen, Händler-CRM und Ihr Team — mit jeden Monat neuen Funktionen.",
    },
    footer: {
      privacy: "Datenschutzerklärung",
      dpa: "AVV",
      support: "Support",
      legal: "Impressum",
      rights: "Alle Rechte vorbehalten.",
    },
  },

  fr: {
    lang: "FR",
    nav: {
      signUp: "S'inscrire",
      signIn: "Se connecter",
      features: "Fonctionnalités",
      pricing: "Tarifs",
      support: "Support",
      dashboard: "Tableau de bord",
    },
    hero: {
      badge: "Gratuit pour chaque partenaire d'application Shopify",
      headline1: "Croissance 360° pour les",
      headline2: "partenaires d'applications Shopify",
      subheadline:
        "Suivez chaque paiement, abonnement, installation, désinstallation et réinstallation de vos applications Shopify — avec analyses et insights de trafic BigQuery, plus CRM marchand, support et avis, le tout au même endroit.",
      cta: "Commencer gratuitement",
      hint: "Installation en 15 min · Gratuit pour toujours · Aucune carte requise",
      alreadyHaveAccount: "Vous avez déjà un compte ?",
      imageLabel: "Tableau de bord Appdesh — paiements, abonnements, installations et churn en un coup d'œil (16:9)",
    },
    stats: {
      founders: "Fondateurs d'applications utilisant Appdesh",
      revenue: "Revenus partenaires suivis",
      setup: "Temps d'installation moyen",
    },
    growthLoop: {
      heading: "Une boucle. Chaque étape de croissance.",
      subheading:
        "Appdesh suit vos marchands tout au long du cycle de vie — acquisition, support et fidélisation au même endroit.",
      diagramLabel: "Diagramme de la boucle de croissance 360° (carré)",
      steps: [
        { title: "Acquérir", description: "Attirez des marchands grâce aux données de trafic et à la découverte organique." },
        { title: "Comprendre", description: "Revenus, MRR, churn et un CRM marchand complet sur toutes vos applications." },
        { title: "Soutenir", description: "Résolvez les problèmes vite avec un support intégré — sans changer d'outil." },
        { title: "Fidéliser", description: "Repérez tôt les signaux de churn et guidez les marchands via des parcours client." },
        { title: "Croître", description: "Transformez les marchands satisfaits en avis et alimentez le prochain cycle de croissance." },
      ],
    },
    features: {
      heading: "Tout ce dont un partenaire d'application Shopify a besoin",
      subheading:
        "Arrêtez de jongler entre cinq outils. Appdesh réunit vos applications, marchands et support dans un espace de travail unique.",
      items: [
        {
          tagline: "Maîtrisez votre économie unitaire",
          title: "Revenus & Analyses d'applications",
          description:
            "Synchronisez automatiquement votre API Shopify Partner. Suivez le MRR, le churn et les performances de vos applications sans tableurs.",
          imageLabel: "Capture — tableau de bord revenus & analyses",
        },
        {
          tagline: "Connaissez vos clients",
          title: "CRM Marchand",
          description:
            "Vue complète de chaque marchand utilisant votre application — plan, date d'installation, activité et notes. Anticipez le churn.",
          imageLabel: "Capture — détail CRM marchand",
        },
        {
          tagline: "Travaillez en équipe",
          title: "Membres de l'équipe",
          description:
            "Invitez votre équipe, attribuez des rôles et gérez les accès — tout le monde reste synchronisé sans partager d'identifiants.",
          imageLabel: "Capture — liste des membres de l'équipe",
        },
      ],
    },
    upcoming: {
      badge: "Bientôt disponible",
      heading: "Ce qui arrive ensuite chez Appdesh",
      subheading:
        "Nous préparons la prochaine vague d'Appdesh — support client, expérimentation et intégrations, avec encore plus à venir.",
      items: [
        {
          tagline: "Répondez vite, fidélisez plus",
          title: "Support client",
          description:
            "Support intégré pour vos clients. Suivez les problèmes et gardez les marchands satisfaits sans quitter Appdesh.",
          imageLabel: "Capture — boîte de réception du support",
        },
        {
          tagline: "Testez en toute sécurité, déployez progressivement",
          title: "Feature Flags & Expérimentations",
          description:
            "Déployez des fonctionnalités expérimentales auprès de groupes de marchands ciblés, lancez des tests A/B et publiez vos changements progressivement — sans redéploiement.",
          imageLabel: "Capture — Feature flags & expérimentations",
        },
        {
          tagline: "Connectez votre flux de travail",
          title: "Intégrations",
          description:
            "Connectez Appdesh à Slack et aux autres outils que votre équipe utilise déjà — soyez averti dès qu'une action est nécessaire, avec encore plus d'intégrations à venir.",
          imageLabel: "Capture — hub d'intégrations",
        },
      ],
    },
    cta: {
      heading: "Prêt à développer votre application Shopify ?",
      subheading: "Toutes les fonctionnalités incluses — gratuit, sans carte bancaire.",
      cta: "S'inscrire gratuitement",
      hint: "Installation en 15 min · Aucune carte bancaire requise",
    },
    featuresPage: {
      heading: "Tout ce qu'Appdesh fait pour les partenaires d'applications Shopify",
      subheading: "Un espace de travail unique pour l'analytique des revenus, le CRM marchand et votre équipe — avec de nouvelles fonctionnalités chaque mois.",
    },
    footer: {
      privacy: "Politique de confidentialité",
      dpa: "DPA",
      support: "Support",
      legal: "Mentions légales",
      rights: "Tous droits réservés.",
    },
  },

  bn: {
    lang: "বাং",
    nav: {
      signUp: "সাইন আপ করুন",
      signIn: "সাইন ইন করুন",
      features: "ফিচার",
      pricing: "মূল্য",
      support: "সহায়তা",
      dashboard: "ড্যাশবোর্ড",
    },
    hero: {
      badge: "প্রতিটি Shopify অ্যাপ পার্টনারের জন্য বিনামূল্যে",
      headline1: "Shopify অ্যাপ পার্টনারদের জন্য",
      headline2: "৩৬০° বৃদ্ধি",
      subheadline:
        "আপনার Shopify অ্যাপগুলোর প্রতিটি পেমেন্ট, সাবস্ক্রিপশন, ইনস্টল, চার্ন এবং রিইনস্টল ট্র্যাক করুন — অ্যানালিটিক্স ও BigQuery ট্রাফিক ইনসাইট, সাথে মার্চেন্ট CRM, হেল্পডেস্ক এবং রিভিউ, সবকিছু এক জায়গায়।",
      cta: "বিনামূল্যে শুরু করুন",
      hint: "১৫ মিনিটে সেটআপ · চিরকাল বিনামূল্যে · কোনো কার্ড লাগবে না",
      alreadyHaveAccount: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
      imageLabel: "Appdesh ড্যাশবোর্ড — পেমেন্ট, সাবস্ক্রিপশন, ইনস্টল ও চার্ন এক নজরে (১৬:৯)",
    },
    stats: {
      founders: "Appdesh ব্যবহারকারী অ্যাপ প্রতিষ্ঠাতা",
      revenue: "পার্টনার রাজস্ব ট্র্যাক করা হয়েছে",
      setup: "গড় সেটআপ সময়",
    },
    growthLoop: {
      heading: "একটি চক্র। বৃদ্ধির প্রতিটি ধাপ।",
      subheading:
        "Appdesh আপনার মার্চেন্টদের পুরো লাইফসাইকেল জুড়ে অনুসরণ করে — অ্যাকুইজিশন, সাপোর্ট এবং রিটেনশন এক জায়গায়।",
      diagramLabel: "৩৬০° বৃদ্ধি চক্র ডায়াগ্রাম (বর্গাকার)",
      steps: [
        { title: "অর্জন", description: "ট্রাফিক ইনসাইট এবং অর্গানিক ডিসকভারির মাধ্যমে মার্চেন্ট আনুন।" },
        { title: "বোঝা", description: "সব অ্যাপ জুড়ে রাজস্ব, MRR, চার্ন এবং সম্পূর্ণ মার্চেন্ট CRM দেখুন।" },
        { title: "সাপোর্ট", description: "বিল্ট-ইন হেল্পডেস্ক দিয়ে দ্রুত সমস্যা সমাধান করুন — টুল বদলানো ছাড়াই।" },
        { title: "ধরে রাখা", description: "চার্ন সংকেত আগেভাগে চিহ্নিত করুন এবং কাস্টমার ফ্লোর মাধ্যমে মার্চেন্টদের পথ দেখান।" },
        { title: "বৃদ্ধি", description: "সন্তুষ্ট মার্চেন্টদের রিভিউতে পরিণত করুন এবং পরবর্তী বৃদ্ধির চক্রে শক্তি যোগান।" },
      ],
    },
    features: {
      heading: "Shopify অ্যাপ পার্টনারের যা দরকার সবই আছে",
      subheading:
        "পাঁচটি টুলের মধ্যে ঘুরে বেড়ানো বন্ধ করুন। Appdesh আপনার অ্যাপ, মার্চেন্ট এবং সাপোর্ট একটি কেন্দ্রীভূত কর্মক্ষেত্রে নিয়ে আসে।",
      items: [
        {
          tagline: "আপনার ইউনিট ইকোনমিক্স জানুন",
          title: "রাজস্ব ও অ্যাপ বিশ্লেষণ",
          description:
            "স্বয়ংক্রিয়ভাবে Shopify Partner API সিঙ্ক করুন। স্প্রেডশিট ছাড়াই MRR, চার্ন এবং অ্যাপ পারফরম্যান্স ট্র্যাক করুন।",
          imageLabel: "স্ক্রিনশট — রাজস্ব ও বিশ্লেষণ ড্যাশবোর্ড",
        },
        {
          tagline: "আপনার গ্রাহকদের জানুন",
          title: "মার্চেন্ট CRM",
          description:
            "প্রতিটি মার্চেন্টের সম্পূর্ণ দৃশ্য — প্ল্যান, ইনস্টল তারিখ, কার্যকলাপ এবং নোট। কে চার্ন করবে তা আর অনুমান করতে হবে না।",
          imageLabel: "স্ক্রিনশট — মার্চেন্ট CRM বিস্তারিত",
        },
        {
          tagline: "এক দল হয়ে কাজ করুন",
          title: "টিম মেম্বার",
          description:
            "আপনার টিমকে আমন্ত্রণ জানান, রোল নির্ধারণ করুন এবং অ্যাক্সেস পরিচালনা করুন — লগইন শেয়ার না করেই সবাই সিঙ্কে থাকবে।",
          imageLabel: "স্ক্রিনশট — টিম মেম্বার তালিকা",
        },
      ],
    },
    upcoming: {
      badge: "শীঘ্রই আসছে",
      heading: "Appdesh-এ পরবর্তী যা আসছে",
      subheading:
        "আমরা Appdesh-এর পরবর্তী ধাপ তৈরি করছি — হেল্পডেস্ক, এক্সপেরিমেন্টেশন এবং ইন্টিগ্রেশন, আরও অনেক কিছু আসার পথে।",
      items: [
        {
          tagline: "দ্রুত উত্তর দিন, বেশি ধরে রাখুন",
          title: "কাস্টমার হেল্পডেস্ক",
          description:
            "আপনার অ্যাপ গ্রাহকদের জন্য বিল্ট-ইন হেল্পডেস্ক। Appdesh না ছেড়েই সমস্যা ট্র্যাক করুন এবং মার্চেন্টদের সন্তুষ্ট রাখুন।",
          imageLabel: "স্ক্রিনশট — হেল্পডেস্ক ইনবক্স",
        },
        {
          tagline: "নিরাপদে পরীক্ষা করুন, ধাপে ধাপে চালু করুন",
          title: "ফিচার ফ্ল্যাগ ও এক্সপেরিমেন্ট",
          description:
            "নির্দিষ্ট মার্চেন্ট গ্রুপের কাছে পরীক্ষামূলক ফিচার চালু করুন, A/B টেস্ট চালান এবং কোনো রিডেপ্লয় ছাড়াই ধাপে ধাপে পরিবর্তন প্রকাশ করুন।",
          imageLabel: "স্ক্রিনশট — ফিচার ফ্ল্যাগ ও এক্সপেরিমেন্ট",
        },
        {
          tagline: "আপনার ওয়ার্কফ্লো যুক্ত করুন",
          title: "ইন্টিগ্রেশন",
          description:
            "Appdesh-কে Slack এবং আপনার টিম ইতিমধ্যে ব্যবহার করে এমন অন্যান্য টুলের সাথে যুক্ত করুন — কোনো কিছুতে নজর দেওয়ার প্রয়োজন হলে সাথে সাথে জানুন, আরও অনেক ইন্টিগ্রেশন আসার পথে।",
          imageLabel: "স্ক্রিনশট — ইন্টিগ্রেশন হাব",
        },
      ],
    },
    cta: {
      heading: "আপনার Shopify অ্যাপ বাড়াতে প্রস্তুত?",
      subheading: "সব ফিচার অন্তর্ভুক্ত — বিনামূল্যে, কোনো ক্রেডিট কার্ড লাগবে না।",
      cta: "বিনামূল্যে সাইন আপ করুন",
      hint: "১৫ মিনিটে সেটআপ · ক্রেডিট কার্ড লাগবে না",
    },
    featuresPage: {
      heading: "Shopify অ্যাপ পার্টনারদের জন্য Appdesh যা কিছু করে",
      subheading: "রাজস্ব অ্যানালিটিক্স, মার্চেন্ট CRM এবং আপনার টিমের জন্য একটি কর্মক্ষেত্র — প্রতি মাসে নতুন ফিচারসহ।",
    },
    footer: {
      privacy: "গোপনীয়তা নীতি",
      dpa: "DPA",
      support: "সহায়তা",
      legal: "আইনি বিজ্ঞপ্তি",
      rights: "সর্বস্বত্ব সংরক্ষিত।",
    },
  },

  it: {
    lang: "IT",
    nav: {
      signUp: "Registrati",
      signIn: "Accedi",
      features: "Funzionalità",
      pricing: "Prezzi",
      support: "Supporto",
      dashboard: "Dashboard",
    },
    hero: {
      badge: "Gratis per ogni partner di app Shopify",
      headline1: "Crescita a 360° per i",
      headline2: "partner di app Shopify",
      subheadline:
        "Monitora ogni pagamento, abbonamento, installazione, abbandono e reinstallazione delle tue app Shopify — con analisi e insight sul traffico da BigQuery, oltre a CRM commercianti, helpdesk e recensioni, tutto in un unico posto.",
      cta: "Inizia gratis",
      hint: "Configurazione in 15 min · Gratis per sempre · Nessuna carta richiesta",
      alreadyHaveAccount: "Hai già un account?",
      imageLabel: "Dashboard Appdesh — pagamenti, abbonamenti, installazioni e abbandono a colpo d'occhio (16:9)",
    },
    stats: {
      founders: "Fondatori di app che usano Appdesh",
      revenue: "Ricavi dei partner monitorati",
      setup: "Tempo medio di configurazione",
    },
    growthLoop: {
      heading: "Un ciclo. Ogni fase della crescita.",
      subheading:
        "Appdesh segue i tuoi commercianti lungo l'intero ciclo di vita — così acquisizione, supporto e retention vivono in un unico posto.",
      diagramLabel: "Diagramma del ciclo di crescita a 360° (quadrato)",
      steps: [
        { title: "Acquisisci", description: "Porta commercianti tramite insight sul traffico e scoperta organica." },
        { title: "Comprendi", description: "Visualizza ricavi, MRR, abbandono e un CRM commercianti completo su tutte le app." },
        { title: "Supporta", description: "Risolvi i problemi velocemente con un helpdesk integrato — senza cambiare strumento." },
        { title: "Trattieni", description: "Individua i segnali di abbandono in anticipo e guida i commercianti nei customer flow." },
        { title: "Cresci", description: "Trasforma i commercianti soddisfatti in recensioni e alimenta il prossimo ciclo di crescita." },
      ],
    },
    features: {
      heading: "Tutto ciò di cui un Partner di app Shopify ha bisogno",
      subheading:
        "Smetti di passare da uno strumento all'altro. Appdesh riunisce le tue app, i commercianti e il supporto in un unico spazio di lavoro focalizzato.",
      items: [
        {
          tagline: "Conosci la tua unit economics",
          title: "Ricavi e analisi delle app",
          description:
            "Sincronizza automaticamente la tua API Shopify Partner. Monitora MRR, abbandono e prestazioni delle app su tutte le tue app — senza fogli di calcolo.",
          imageLabel: "Screenshot — dashboard di ricavi e analisi",
        },
        {
          tagline: "Conosci i tuoi clienti",
          title: "CRM commercianti",
          description:
            "Una visione completa di ogni commerciante che usa la tua app — piano, data di installazione, attività e note. Smetti di indovinare chi potrebbe abbandonare.",
          imageLabel: "Screenshot — dettaglio CRM commercianti",
        },
        {
          tagline: "Lavorate come un unico team",
          title: "Membri del team",
          description:
            "Invita il tuo team, assegna ruoli e gestisci gli accessi — tutti restano allineati senza condividere le credenziali.",
          imageLabel: "Screenshot — elenco membri del team",
        },
      ],
    },
    upcoming: {
      badge: "Prossimamente",
      heading: "Cosa arriva dopo per Appdesh",
      subheading:
        "Stiamo costruendo la prossima ondata di Appdesh — helpdesk, sperimentazione e integrazioni, con altro ancora in arrivo.",
      items: [
        {
          tagline: "Rispondi più in fretta, trattieni di più",
          title: "Helpdesk clienti",
          description:
            "Helpdesk integrato per i clienti della tua app. Monitora i problemi, rispondi rapidamente e mantieni i commercianti soddisfatti senza lasciare Appdesh.",
          imageLabel: "Screenshot — inbox helpdesk",
        },
        {
          tagline: "Testa in sicurezza, rilascia gradualmente",
          title: "Feature Flags & Esperimenti",
          description:
            "Distribuisci funzionalità sperimentali a gruppi specifici di commercianti, esegui test A/B e rilascia modifiche gradualmente — senza bisogno di un nuovo deploy.",
          imageLabel: "Screenshot — feature flags & esperimenti",
        },
        {
          tagline: "Collega il tuo flusso di lavoro",
          title: "Integrazioni",
          description:
            "Collega Appdesh a Slack e agli altri strumenti già usati dal tuo team — ricevi una notifica non appena serve attenzione, con molte altre integrazioni in arrivo.",
          imageLabel: "Screenshot — hub delle integrazioni",
        },
      ],
    },
    cta: {
      heading: "Pronto a far crescere la tua app Shopify?",
      subheading: "Tutte le funzionalità incluse — gratis, senza carta di credito.",
      cta: "Registrati gratis",
      hint: "Configurazione in 15 min · Nessuna carta di credito richiesta",
    },
    featuresPage: {
      heading: "Tutto ciò che Appdesh fa per i Partner di app Shopify",
      subheading: "Un unico spazio di lavoro per analisi dei ricavi, CRM commercianti e il tuo team — con nuove funzionalità ogni mese.",
    },
    footer: {
      privacy: "Informativa sulla privacy",
      dpa: "DPA",
      support: "Supporto",
      legal: "Note legali",
      rights: "Tutti i diritti riservati.",
    },
  },

  es: {
    lang: "ES",
    nav: {
      signUp: "Regístrate",
      signIn: "Iniciar sesión",
      features: "Funciones",
      pricing: "Precios",
      support: "Soporte",
      dashboard: "Panel",
    },
    hero: {
      badge: "Gratis para cada partner de apps de Shopify",
      headline1: "Crecimiento 360° para",
      headline2: "Partners de apps de Shopify",
      subheadline:
        "Rastrea cada pago, suscripción, instalación, baja y reinstalación de tus apps de Shopify — con analítica e insights de tráfico de BigQuery, además de CRM de comercios, help desk y reseñas, todo en un solo lugar.",
      cta: "Empieza gratis",
      hint: "Configuración en 15 min · Gratis para siempre · Sin tarjeta requerida",
      alreadyHaveAccount: "¿Ya tienes una cuenta?",
      imageLabel: "Panel de Appdesh — pagos, suscripciones, instalaciones y bajas de un vistazo (16:9)",
    },
    stats: {
      founders: "Fundadores de apps que usan Appdesh",
      revenue: "Ingresos de partners rastreados",
      setup: "Tiempo medio de configuración",
    },
    growthLoop: {
      heading: "Un ciclo. Cada etapa del crecimiento.",
      subheading:
        "Appdesh acompaña a tus comercios durante todo el ciclo de vida — para que adquisición, soporte y retención vivan en un solo lugar.",
      diagramLabel: "Diagrama del ciclo de crecimiento 360° (cuadrado)",
      steps: [
        { title: "Adquirir", description: "Atrae comercios mediante insights de tráfico y descubrimiento orgánico." },
        { title: "Entender", description: "Visualiza ingresos, MRR, bajas y un CRM de comercios completo en todas las apps." },
        { title: "Soportar", description: "Resuelve problemas rápido con un help desk integrado — sin cambiar de herramienta." },
        { title: "Retener", description: "Detecta señales de baja a tiempo y guía a los comercios a través de flujos de clientes." },
        { title: "Crecer", description: "Convierte a los comercios satisfechos en reseñas e impulsa la siguiente ronda de crecimiento." },
      ],
    },
    features: {
      heading: "Todo lo que necesita un Partner de apps de Shopify",
      subheading:
        "Deja de saltar entre cinco herramientas. Appdesh reúne tus apps, comercios y soporte en un espacio de trabajo enfocado.",
      items: [
        {
          tagline: "Conoce tu economía unitaria",
          title: "Analítica de ingresos y apps",
          description:
            "Sincroniza tu API de Shopify Partner automáticamente. Rastrea MRR, bajas y rendimiento de apps en todas tus apps — sin hojas de cálculo.",
          imageLabel: "Captura — panel de ingresos y analítica",
        },
        {
          tagline: "Conoce a tus clientes",
          title: "CRM de comercios",
          description:
            "Una vista completa de cada comercio que usa tu app — plan, fecha de instalación, actividad y notas. Deja de adivinar quién podría darse de baja.",
          imageLabel: "Captura — detalle del CRM de comercios",
        },
        {
          tagline: "Trabajen como un solo equipo",
          title: "Miembros del equipo",
          description:
            "Invita a tu equipo, asigna roles y gestiona los accesos — todos se mantienen sincronizados sin compartir credenciales.",
          imageLabel: "Captura — lista de miembros del equipo",
        },
      ],
    },
    upcoming: {
      badge: "Próximamente",
      heading: "Qué sigue para Appdesh",
      subheading:
        "Estamos construyendo la próxima ola de Appdesh — help desk, experimentación e integraciones, con más en camino.",
      items: [
        {
          tagline: "Responde más rápido, retén más",
          title: "Help desk de clientes",
          description:
            "Help desk integrado para los clientes de tu app. Rastrea incidencias, responde rápido y mantén contentos a los comercios sin salir de Appdesh.",
          imageLabel: "Captura — bandeja de entrada del help desk",
        },
        {
          tagline: "Prueba con seguridad, lanza gradualmente",
          title: "Feature Flags y Experimentos",
          description:
            "Lanza funciones experimentales a grupos específicos de comercios, ejecuta pruebas A/B y despliega cambios de forma gradual — sin necesidad de un nuevo despliegue.",
          imageLabel: "Captura — feature flags y experimentos",
        },
        {
          tagline: "Conecta tu flujo de trabajo",
          title: "Integraciones",
          description:
            "Conecta Appdesh con Slack y otras herramientas que tu equipo ya usa — recibe una notificación en cuanto algo necesite atención, con muchas más integraciones en camino.",
          imageLabel: "Captura — panel de integraciones",
        },
      ],
    },
    cta: {
      heading: "¿Listo para hacer crecer tu app de Shopify?",
      subheading: "Todas las funciones incluidas — gratis, sin tarjeta de crédito.",
      cta: "Regístrate gratis",
      hint: "Configuración en 15 min · No se requiere tarjeta de crédito",
    },
    featuresPage: {
      heading: "Todo lo que Appdesh hace por los Partners de aplicaciones de Shopify",
      subheading: "Un solo espacio de trabajo para analítica de ingresos, CRM de comercios y tu equipo — con nuevas funciones cada mes.",
    },
    footer: {
      privacy: "Política de privacidad",
      dpa: "DPA",
      support: "Soporte",
      legal: "Aviso legal",
      rights: "Todos los derechos reservados.",
    },
  },
}
